module.exports = __webpack_public_path__ + "static/media/drums.33a0290c.mp3";